/* eslint-disable line-comment-position
 */
const currencySymbols: Record<string, string> = {
  USD: "$", // US Dollar
  EUR: "€", // Euro
  GBP: "£", // British Pound Sterling
  INR: "₹", // Indian Rupee
  JPY: "¥", // Japanese Yen
  AUD: "A$", // Australian Dollar
  CAD: "C$", // Canadian Dollar
  CHF: "CHF", // Swiss Franc
  CNY: "¥", // Chinese Yuan
  SEK: "kr", // Swedish Krona
  NZD: "NZ$", // New Zealand Dollar
  MXN: "$", // Mexican Peso
  SGD: "S$", // Singapore Dollar
  HKD: "HK$", // Hong Kong Dollar
  NOK: "kr", // Norwegian Krone
  KRW: "₩", // South Korean Won
  TRY: "₺", // Turkish Lira
  RUB: "₽", // Russian Ruble
  ZAR: "R", // South African Rand
  BRL: "R$", // Brazilian Real
  MYR: "RM", // Malaysian Ringgit
  IDR: "Rp", // Indonesian Rupiah
  THB: "฿", // Thai Baht
  VND: "₫", // Vietnamese Dong
  PHP: "₱", // Philippine Peso
  ILS: "₪", // Israeli New Shekel
  PLN: "zł", // Polish Zloty
  HUF: "Ft", // Hungarian Forint
  CZK: "Kč", // Czech Koruna
  DKK: "kr", // Danish Krone
  AED: "د.إ", // United Arab Emirates Dirham
  SAR: "﷼", // Saudi Riyal
  BGN: "лв", // Bulgarian Lev
  RON: "lei", // Romanian Leu
  CLP: "$", // Chilean Peso
  COP: "$", // Colombian Peso
  ARS: "$", // Argentine Peso
  PEN: "S/", // Peruvian Sol
  PKR: "₨", // Pakistani Rupee
  NGN: "₦", // Nigerian Naira
  EGP: "£", // Egyptian Pound
  KES: "KSh", // Kenyan Shilling
};
/* eslint-enable line-comment-position
 */

export const getCurrencySymbol = (currencyCode: string): string => {
  return currencySymbols[currencyCode?.toUpperCase()] || currencyCode;
};
